import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import Filters from './components/inputs/'
import Tables from './components/tables';
import TablesStock from './components/tablesStock';
import ChartsLiner from './components/charts/index';

let useStyles = makeStyles((theme) => ({
    root: {
        padding: '20px',
        [theme.breakpoints.down("700")]: {
            width:'100%',
            padding: '5px',
        },
    },
    grid: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginTop: 20,
        [theme.breakpoints.down("1100")]: {
          flexDirection:'column'
        },
    }
}))


export default function Index() {

    let classes = useStyles();

    const [stock, setStock] = useState({});
    const [state, setState] = useState({
        commodity_id: null,
        main_category: null,
        category: null,
        sub_category: null,
        date_from: null,
        date_to: null,
    });

    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(10);
    const [flegApi, setFlagApi] = useState(false);


    return (
        <>
            <div className={classes['root']}>
                <Filters
                    state={state}
                    setState={setState}
                    setFlagApi={setFlagApi}
                />
                <Tables
                    page={page}
                    state={state}
                    flegApi={flegApi}
                    setPage={setPage}
                    rowsPerPage={rowsPerPage}
                    stock={stock}
                    setStock={setStock}
                />
                <div className={classes['grid']}>
                <TablesStock
                    data={state}
                    stock={stock}
                    setStock={setStock}
                />
                <ChartsLiner />
                </div>
            </div>
        </>

    )
}
